import { useTranslation } from 'react-i18next';

export const StripeNewPaymentMethodNonEditable = () => {
  const { t } = useTranslation();

  // Don't show "submitting payment" message here to avoid duplicate with PaymentProcessingInfoWidget
  return <div className="stripe-payment-method-ready">{t('payment-methods.payment_method_ready')}</div>;
};
